import PropTypes from 'prop-types';

import {Box} from '@salesforce/retail-react-app/app/components/shared/ui';

import {Component} from '@amblique/king-living/app/components/contentful/component';

/**
 * Editorial Copy (CF-021)
 *
 * @typedef {import('@chakra-ui/styled-system').SystemStyleObject} SystemStyleObject
 * @typedef {"root"} SectionPanelParts
 * @typedef {Partial<Record<SectionPanelParts, SystemStyleObject>>} SectionPanelStyles
 *
 * @param {Object} props - Component props
 * @param {Contentful.SectionPanel} props.component - SectionPanel component data
 * @param {boolean} [props.isComplete] - Whether component has all fields
 * @param {boolean} [props.isFetching] - Whether additional data is being fetched
 * @param {SectionPanelStyles} [props.styles] - Whether additional data is being fetched
 * @param {string} [props.className] - Merged after the stable editorial-copy CF-021 container class
 * @returns {React.ReactElement}
 */
const EDITORIAL_CF021_CONTAINER_CLASS = 'editorial-container';

export const EditorialCopyCF021 = ({
  component,
  isComplete = true,
  isFetching = false,
  styles,
  className,
  ...props
}) => {
  const {contentCollection} = component || {};

  if (!contentCollection?.items) {
    return null;
  }

  const validItems = contentCollection.items.filter(
    (item) => item != null && typeof item === 'object' && item.__typename && item.sys?.id
  );

  if (validItems.length === 0) {
    return null;
  }

  return (
    <Box
      {...styles.container}
      {...props}
      className={[EDITORIAL_CF021_CONTAINER_CLASS, styles.container?.className, className].filter(Boolean).join(
        ' '
      )}
    >
      <Component
        key={validItems[0].sys.id}
        component={validItems[0]}
        isComplete={isComplete}
        isFetching={isFetching}
        styles={styles}
      />
    </Box>
  );
};

EditorialCopyCF021.displayName = 'EditorialCopyCF021';
EditorialCopyCF021.propTypes = {
  className: PropTypes.string,
  component: PropTypes.object.isRequired,
  isComplete: PropTypes.bool,
  isFetching: PropTypes.bool,
  styles: PropTypes.object.isRequired,
};
